import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=322f15bc"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=322f15bc&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Payment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322f15bc')) {
      api.createRecord('322f15bc', component.options)
    } else {
      api.reload('322f15bc', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=322f15bc", function () {
      api.rerender('322f15bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment.vue"
export default component.exports